var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isChecklistActive)?_c('div',{staticClass:"checklist__next-step"},[_c('AppCheckbox',{attrs:{"id":`checklist-next-step--${_vm.checklistId}`,"label":_vm.label},on:{"input":_vm.nextStep}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }